module.exports = __webpack_public_path__ + "static/girl_cinsa-058b97cca4df976a8c11066440120fea.png";